/* Sage product pop-up (CRYSTAL-2078, Oct 21 2026). Matches the selected variant's Material to a Sage crystal,
   shows a "More about X" link under the buy buttons, and opens the Sage card in a pop-up. */
(function(){
  'use strict';
  if (window.__sagePP) return; window.__sagePP = true;

  var roots = [].slice.call(document.querySelectorAll('[data-sage-pp]'));
  if (!roots.length) return;
  var first = roots[0];
  var URLS = { match: first.dataset.match, cards: first.dataset.cards, core: first.dataset.core };
  var MATCH = null, CARDS = null, corePromise = null, cardsPromise = null;
  var aliasIdx = [], matNorm = {}, nameById = {};

  function norm(s){ return (s || '').toLowerCase().replace(/[\u2018\u2019]/g, "'").replace(/[^a-z0-9' ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function getJSON(u){ return fetch(u, { credentials: 'same-origin' }).then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function loadScript(u){ return new Promise(function(res, rej){ var s = document.createElement('script'); s.src = u; s.onload = res; s.onerror = rej; document.head.appendChild(s); }); }
  function track(name, extra){ try { window.dataLayer = window.dataLayer || []; var o = { event: name }; for (var k in extra) o[k] = extra[k]; window.dataLayer.push(o); } catch (e) {} }

  function buildIndex(){
    MATCH.a.forEach(function(r){
      nameById[r[0]] = r[1];
      var seen = {};
      [r[1]].concat(r[2] || []).forEach(function(al){ var n = norm(al); if (n && !seen[n]) { seen[n] = 1; aliasIdx.push([n, r[0]]); } });
    });
    aliasIdx.sort(function(x, y){ return y[0].length - x[0].length; });
    Object.keys(MATCH.m).forEach(function(k){ matNorm[norm(k)] = MATCH.m[k]; });
  }
  function findIn(text){
    var t = ' ' + norm(text) + ' ';
    for (var i = 0; i < aliasIdx.length; i++) { if (t.indexOf(' ' + aliasIdx[i][0] + ' ') > -1) return aliasIdx[i][1]; }
    return null;
  }
  function matchMaterial(val){
    var n = norm(val);
    if (!n) return null;
    if (n === 'mixed gemstones' || n === 'mixed gemstone' || n === 'mixed stones' || n === 'mixed') return 'MIXED';
    if (matNorm[n]) return matNorm[n];
    return findIn(val);
  }

  function currentVariantId(root){
    var scope = root.closest('form') ? root.closest('form').parentNode : root.parentNode;
    var sec = root.closest('[data-section-type="product"]') || scope || document;
    var sel = sec.querySelector('[name="id"]');
    if (sel && sel.value) return String(sel.value);
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function resolve(root){
    var variants = {};
    try { variants = JSON.parse(root.querySelector('[data-sage-pp-variants]').textContent); } catch (e) {}
    var idx = parseInt(root.dataset.materialIndex, 10);
    var id = null;
    if (idx >= 0) {
      var vid = currentVariantId(root);
      var val = (vid && variants[vid] != null) ? variants[vid] : variants[Object.keys(variants)[0]];
      id = matchMaterial(val);
      if (id === 'MIXED') return null;
    }
    if (!id) id = findIn(root.dataset.title);
    return id;
  }

  function update(root){
    if (!MATCH) return;
    var id = resolve(root);
    root.dataset.crystal = id || '';
    if (id && nameById[id]) {
      root.querySelector('[data-sage-pp-name]').textContent = nameById[id];
      root.hidden = false;
    } else {
      root.hidden = true;
    }
  }

  /* ---------- modal ---------- */
  var modal, lastFocus;
  function el(tag, cls, text){ var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function ensureModal(){
    if (modal) return modal;
    modal = el('div', 'sage-ppm');
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'sage-ppm-title');
    modal.innerHTML = '<div class="sage-ppm__backdrop" data-close></div>' +
      '<div class="sage-ppm__panel">' +
      '<button type="button" class="sage-ppm__x" aria-label="Close" data-close>&times;</button>' +
      '<p class="sage-ppm__kicker">Crystal Destiny Sage</p>' +
      '<h2 class="sage-ppm__title" id="sage-ppm-title"></h2>' +
      '<p class="sage-ppm__family"></p>' +
      '<div class="sage-ppm__pills"></div>' +
      '<p class="sage-ppm__summary"></p>' +
      '<dl class="sage-ppm__facts"></dl>' +
      '<div class="sage-ppm__actions"><a class="sage-ppm__read" hidden>Read more</a><a class="sage-ppm__sage">Open full profile in Sage</a></div>' +
      '<p class="sage-ppm__note">Crystal traditions and meanings are shared for interest and are not medical advice.</p>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function(e){ if (e.target.hasAttribute('data-close')) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) close(); });
    modal.querySelector('.sage-ppm__read').addEventListener('click', function(){ track('sage_popup_read_more', { crystal_id: modal.dataset.crystal }); });
    modal.querySelector('.sage-ppm__sage').addEventListener('click', function(){ track('sage_popup_open_sage', { crystal_id: modal.dataset.crystal }); });
    return modal;
  }
  function fact(dl, label, value){
    if (!value || (Array.isArray(value) && !value.length)) return;
    dl.appendChild(el('dt', null, label));
    dl.appendChild(el('dd', null, Array.isArray(value) ? value.join(', ') : String(value)));
  }
  function fill(id){
    var c = CARDS.cards[id]; if (!c) return false;
    var m = ensureModal();
    m.dataset.crystal = id;
    m.querySelector('.sage-ppm__title').textContent = c.n;
    m.querySelector('.sage-ppm__family').textContent = c.f || '';
    var pills = m.querySelector('.sage-ppm__pills'); pills.innerHTML = '';
    if (c.r) pills.appendChild(el('span', 'sage-ppm__pill', c.r));
    (c.c || []).slice(0, 3).forEach(function(ch){ pills.appendChild(el('span', 'sage-ppm__pill sage-ppm__pill--soft', ch + ' Chakra')); });
    m.querySelector('.sage-ppm__summary').textContent = c.s || '';
    var dl = m.querySelector('.sage-ppm__facts'); dl.innerHTML = '';
    fact(dl, 'Known for', (c.m || []).slice(0, 5));
    fact(dl, 'Zodiac', c.z);
    fact(dl, 'Element', c.e);
    if (c.h) fact(dl, 'Hardness', c.h + ' (Mohs)');
    m.querySelector('.sage-ppm__sage').href = '/pages/crystal-quiz?crystal=' + encodeURIComponent(id);
    var read = m.querySelector('.sage-ppm__read'); read.hidden = true;
    loadCore().then(function(){
      var api = window.SageReadMore; if (!api) return;
      return api.load().then(function(){
        if (m.dataset.crystal !== id) return;
        var r = api.linkFor(id);
        if (r && r[0]) { read.href = r[0]; read.textContent = 'Read more about ' + c.n; read.hidden = false; }
      });
    }).catch(function(){});
    return true;
  }
  function open(root){
    var id = root.dataset.crystal; if (!id) return;
    lastFocus = document.activeElement;
    track('sage_popup_open', { crystal_id: id, product_title: root.dataset.title });
    loadCards().then(function(){
      if (!fill(id)) { location.href = '/pages/crystal-quiz?crystal=' + encodeURIComponent(id); return; }
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      modal.querySelector('.sage-ppm__x').focus();
    }).catch(function(){ location.href = '/pages/crystal-quiz?crystal=' + encodeURIComponent(id); });
  }
  function close(){
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function loadCards(){ if (!cardsPromise) cardsPromise = getJSON(URLS.cards).then(function(j){ CARDS = j; }); return cardsPromise; }
  function loadCore(){ if (!corePromise) corePromise = window.SageReadMore ? Promise.resolve() : loadScript(URLS.core); return corePromise; }

  /* ---------- wire up ---------- */
  function refreshAll(){ roots.forEach(update); }
  roots.forEach(function(root){
    root.querySelector('[data-sage-pp-open]').addEventListener('click', function(){ open(root); });
    var sec = root.closest('[data-section-type="product"]') || document;
    sec.addEventListener('change', function(){ setTimeout(function(){ update(root); }, 60); });
    sec.addEventListener('click', function(e){ if (e.target.closest('.variant-input-wrap, .variant__button, label')) setTimeout(function(){ update(root); }, 60); });
  });
  document.addEventListener('variant:change', function(){ setTimeout(refreshAll, 30); });
  window.addEventListener('popstate', function(){ setTimeout(refreshAll, 30); });

  function init(){ getJSON(URLS.match).then(function(j){ MATCH = j; buildIndex(); refreshAll(); }).catch(function(){}); }
  if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 2500 }); else setTimeout(init, 800);
})();
